module.exports = __webpack_public_path__ + "media/img/illustrations/female-d1ddad8166280031ec7a642d7b842e9c.svg";